import * as Form from './form';

const formElement = document.querySelector('[data-garbage-abc-form]');
const formResults = document.querySelector('[data-garbage-abc-results]');
const noticeElement = document.querySelector('[data-notice]');

export function suggestionHandler() {
    const suggestionButtons = formResults.querySelectorAll('a');
    const formInput = formElement.querySelector('input[type="search"]');

    suggestionButtons.forEach((item) => {
        item.addEventListener('click', (e) => {
            e.preventDefault();
            formInput.value = item.innerText;
            formElement.submit();
        });
    });
}

export function showSuggestions(json) {
    let formResultsHtml = formResults.innerHTML;

    if (json.length > 0) {
        Object.keys(json).forEach((item) => {
            formResultsHtml += `<a href="/" class="px-2 py-1">${json[item]}</a>`;
        });

        formResults.innerHTML = formResultsHtml;
        formResults.setAttribute('aria-hidden', 'false');
    } else {
        formResults.innerHTML = '<span class="px-2 py-1">Geen resultaten</span>';
        formResults.setAttribute('aria-hidden', 'false');
    }

    suggestionHandler();
}

export function resetGarbageAbcForm() {
    formResults.setAttribute('aria-hidden', 'true');
    formResults.innerHTML = '';

    Form.hideNotice(formElement, noticeElement);
}

export function getSuggestions(formSearchInput) {
    const Request = new XMLHttpRequest();
    Request.open('GET', `${formElement.getAttribute('data-change-route')}/${formSearchInput.value}`);
    Request.setRequestHeader('Accept', 'application/json');
    formElement.setAttribute('aria-busy', 'true');

    resetGarbageAbcForm();

    let called = false;
    Request.onreadystatechange = () => {
        if (Request.readyState === XMLHttpRequest.DONE && !called) {
            if (Request.status === 0 || (Request.status >= 200 && Request.status < 400)) {
                showSuggestions(JSON.parse(Request.responseText));
            } else if ([500, 404, 422].includes(Request.status)) {
                showSuggestions([]);
            }

            called = true;
            formElement.setAttribute('aria-busy', 'false');
        }
    };

    Request.send(new FormData(formElement));
}

export default function initGarbageAbcSearch() {
    if (formElement) {
        const formSearchInput = formElement.querySelector('input[type="search"]');
        let timer;

        formSearchInput.addEventListener('keyup', (e) => {
            if (e.keyCode === 40) {
                formResults.firstElementChild.focus();
                document.addEventListener('keydown', (e) => {
                    const nextFocus = document.activeElement.nextElementSibling;
                    const prevFocus = document.activeElement.previousElementSibling;
                    const inputKeyCode = e.keyCode;

                    if (inputKeyCode === 40) {
                        e.preventDefault();
                        if (nextFocus) {
                            nextFocus.focus();
                        }
                    } else if (inputKeyCode === 38) {
                        e.preventDefault();
                        if (prevFocus) {
                            prevFocus.focus();
                        }
                    } else {
                        formSearchInput.focus();
                    }
                });
            } else {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    getSuggestions(formSearchInput);
                }, 200);
            }
        });
    }
}
